import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { useAsync } from '@sde/widgets-core/src/redux/hooks/useAsync';
import { getOnboarding, setOnboarding } from './actions';
import { GET_ONBOARDING, SET_ONBOARDING } from './constants';

const onboardingSelector = (state) => state.onboarding;

export const useOnboarding = {
  state: () => {
    return useSelect(onboardingSelector);
  },
  actions: () => {
    return {
      getOnboarding: useAction(getOnboarding, {
        saga: useAsync(GET_ONBOARDING),
      }),
      setOnboarding: useAction(setOnboarding, {
        saga: useAsync(SET_ONBOARDING),
      }),
    };
  },
};
